<script setup lang="ts">
import MxIcon from './MxIcon.vue';

defineProps<{
  icon?: string;
  emoji?: string;
  label: string;
  active?: boolean;
  badge?: 'popular' | 'new';
  size?: 'md' | 'lg';
}>();
</script>

<template>
  <button :class="['ib', `ib--${size ?? 'md'}`, { 'ib--active': active }]">
    <span class="ib__bubble">
      <span v-if="emoji" class="ib__emoji">{{ emoji }}</span>
      <MxIcon v-else-if="icon" :name="icon" :size="size === 'lg' ? 26 : 22" />
      <span v-if="badge" :class="['ib__badge', `ib__badge--${badge}`]">
        {{ badge === 'popular' ? '🔥' : '✦' }}
      </span>
    </span>
    <span class="ib__lbl">{{ label }}</span>
  </button>
</template>

<style scoped>
.ib {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  background: transparent;
  -webkit-tap-highlight-color: transparent;
  flex: 0 0 auto;
}
.ib__bubble {
  position: relative;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--bg-elevated);
  border: 1px solid var(--hairline);
  transition: transform 0.12s ease, border-color 0.18s ease, background 0.18s ease;
}
.ib--md .ib__bubble { width: 56px; height: 56px; }
.ib--lg .ib__bubble { width: 64px; height: 64px; }
.ib:active .ib__bubble { transform: scale(0.94); }
.ib--active .ib__bubble {
  border-color: var(--accent);
  background:
    radial-gradient(120% 100% at 0% 0%, var(--accent-soft) 0%, transparent 60%),
    var(--bg-elevated);
}
.ib__emoji { font-size: 26px; line-height: 1; }
.ib__lbl {
  font-size: var(--fs-xs);
  color: var(--text-secondary);
  font-weight: 500;
  max-width: 80px;
  text-align: center;
  line-height: 1.15;
}
.ib--active .ib__lbl { color: var(--text-primary); }
.ib__badge {
  position: absolute;
  top: -2px;
  right: -2px;
  font-size: 11px;
  background: var(--accent);
  color: #000;
  border-radius: 10px;
  padding: 1px 5px;
  line-height: 1.2;
}
</style>
